var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"vue-form__answer-button",class:{ selected: _vm.isSelected },on:{"click":_vm.select}},[(_vm.keyboard)?_c('span',{staticClass:"vue-form__answer-button__key-hint"}):_vm._e(),_vm._l((_vm.words),function(word){return _c('b-col',{key:word},[_vm._v("\n    "+_vm._s(word)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }